import { registerPlugin } from '@capacitor/core';
export interface QrPlugin {
  transparent():Promise<void>
  destroy():Promise<void>
}

const Qr = registerPlugin<QrPlugin>("Qr");

export default Qr;